import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { CalendarIcon } from '@import/icons';
var BaseIconInput = function (_a) {
    var onClick = _a.onClick;
    return (_jsx("div", { className: 'cursor-pointer w-fit h-4', onClick: onClick, children: _jsx(CalendarIcon, { width: 16 }) }));
};
export default memo(BaseIconInput);
